export const SCREEN_WIDTH = 960;
export const SCREEN_HEIGHT = 540;
export const gameCanvasId = 'gamecanvas';

export const gameData = {
  vitality: 500,
  maxVitality: 500,
  steps: 0,
};



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/